/* eslint-disable */
// =====================================================================
// AI DÜŞÜNÜYOR ANİMASYONU — teknik metin içermeyen akıcı yükleme göstergesi
// ---------------------------------------------------------------------
// İki varyant:
//   <AiThinkingLoader />          → sayfa/kart içi büyük varyant
//     (yüzen ✨ gradyan küre + parlayan halka + seken noktalar + ışıltı çubuğu)
//   <AiThinkingLoader compact />  → sohbet balonu içi "yazıyor" varyantı
// Kullanım yerleri: AI Rapor Asistanı (/reports/ai-query) ve AY Asistan.
// =====================================================================
import { FC } from 'react';

const CSS = `
@keyframes aiOrbFloat {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-7px) scale(1.06); }
}
@keyframes aiOrbGlow {
  0%, 100% { box-shadow: 0 0 16px rgba(114,57,234,.35), 0 0 34px rgba(62,151,255,.18); }
  50% { box-shadow: 0 0 30px rgba(114,57,234,.6), 0 0 62px rgba(62,151,255,.38); }
}
@keyframes aiRing {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@keyframes aiDotBounce {
  0%, 80%, 100% { transform: scale(.55); opacity: .35; }
  40% { transform: scale(1); opacity: 1; }
}
@keyframes aiShimmer {
  0% { background-position: -180% 0; }
  100% { background-position: 180% 0; }
}
.ai-loader-orb-wrap { position: relative; width: 72px; height: 72px; margin: 0 auto; }
.ai-loader-orb {
  position: absolute; inset: 8px; border-radius: 50%;
  background: linear-gradient(135deg, #7239ea 0%, #3e97ff 100%);
  display: flex; align-items: center; justify-content: center;
  font-size: 24px; color: #fff;
  animation: aiOrbFloat 2.4s ease-in-out infinite, aiOrbGlow 2.4s ease-in-out infinite;
}
.ai-loader-ring {
  position: absolute; inset: 0; border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: rgba(114,57,234,.55);
  border-right-color: rgba(62,151,255,.35);
  animation: aiRing 1.6s linear infinite;
}
.ai-loader-dots { display: flex; gap: 7px; justify-content: center; }
.ai-loader-dots span {
  width: 9px; height: 9px; border-radius: 50%;
  background: linear-gradient(135deg, #7239ea, #3e97ff);
  animation: aiDotBounce 1.3s ease-in-out infinite;
}
.ai-loader-dots span:nth-child(2) { animation-delay: .18s; }
.ai-loader-dots span:nth-child(3) { animation-delay: .36s; }
.ai-loader-shimmer {
  width: 190px; height: 6px; border-radius: 3px; margin: 0 auto;
  background: linear-gradient(90deg, rgba(114,57,234,.08) 25%, rgba(114,57,234,.4) 50%, rgba(62,151,255,.08) 75%);
  background-size: 180% 100%;
  animation: aiShimmer 1.8s ease-in-out infinite;
}
.ai-loader-compact { display: flex; align-items: center; gap: 8px; padding: 2px 4px; }
.ai-loader-compact .ai-loader-dots span { width: 8px; height: 8px; }
`;

interface Props {
  /** Sohbet balonu içi küçük "yazıyor" varyantı */
  compact?: boolean;
}

const AiThinkingLoader: FC<Props> = ({ compact }) => {
  if (compact) {
    return (
      <div className="ai-loader-compact">
        <style>{CSS}</style>
        <span style={{ fontSize: 15 }}>✨</span>
        <div className="ai-loader-dots">
          <span />
          <span />
          <span />
        </div>
      </div>
    );
  }

  return (
    <div className="text-center py-6">
      <style>{CSS}</style>
      <div className="ai-loader-orb-wrap mb-5">
        <div className="ai-loader-ring" />
        <div className="ai-loader-orb">✨</div>
      </div>
      <div className="ai-loader-dots mb-5">
        <span />
        <span />
        <span />
      </div>
      <div className="ai-loader-shimmer" />
    </div>
  );
};

export default AiThinkingLoader;
